import React from "react";
import { IComponent, IFlexible } from "@/src/components/core-blocks/Flexible";
import Flexible from "@/src/components/core-blocks/Flexible";
import { IGlobalComponents } from "@/src/types";

export interface GlobalComponentProps {
  blockId: string;
  component: number;
  globalComponents?: IGlobalComponents;
}

const GlobalComponent: React.FC<GlobalComponentProps> = ({
  blockId = "",
  component,
  globalComponents,
}) => {
  const selectedComponent = globalComponents?.find(
    (c) => c.databaseId === Number(component)
  );

  const isIComponentArray = (
    flexible: IFlexible | IComponent[]
  ): flexible is IComponent[] => {
    return Array.isArray(flexible);
  };

  return (
    <div id={blockId}>
      {selectedComponent?.globalComponents?.global &&
      isIComponentArray(selectedComponent.globalComponents.global) ? (
        <Flexible components={selectedComponent.globalComponents.global} />
      ) : null}
    </div>
  );
};

export default GlobalComponent;
